export enum SubscriptionOptionsFormDescription {
  YES = 'Ja',
  NO = 'Nein',
  DESC_YES = 'Ja, ich möchte einen oder mehrere Bezugsberechtigte bestimmen.',
  DESC_NO = 'Ich möchte, dass die Leistung an meine gesetzlichen Erben ausgezahlt wird.'
}
